export interface PresenterPoseVariant {
  id: string;
  variant?: string | null;
  processingStatus?: string | null;
  createdAt: string;
  metadata?: unknown;
}

function objectMetadata(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? value as Record<string, unknown> : {};
}

export function latestPresenterPoseAssetIds(variants: readonly PresenterPoseVariant[]): Record<string, string> {
  const rank = (variant: PresenterPoseVariant) => {
    const version = objectMetadata(variant.metadata).poseVersion;
    return version === 'v3' ? 3 : version === 'v2' ? 2 : 1;
  };
  const sorted = [...variants].sort((a, b) => rank(b) - rank(a) || (Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0));
  const selected: Record<string, string> = {};
  for (const variant of sorted) {
    const metadata = objectMetadata(variant.metadata);
    if (variant.processingStatus !== 'COMPLETED' || metadata.source !== 'pins-shorts-presenter-pose' || metadata.contentType === 'pins-shorts-presenter-pose-source') continue;
    const pose = typeof metadata.pose === 'string' ? metadata.pose : variant.variant?.startsWith('pose:') ? variant.variant.slice(5) : '';
    if (pose && !selected[`pose:${pose}`]) selected[`pose:${pose}`] = variant.id;
  }
  return selected;
}
